<template>
    <div class="conditionally-approve-wizard restructure-wizard">
        <loan-notes-component v-if="wizardStep === 0" 
            :loan-id="loanId" 
            :wizard-view="true"
            :default-note="'Loan requires restructure'"
            v-on:wizardnoteadded="addWizardNote"></loan-notes-component>

        <div class="review-save__container" v-if="wizardStep === 1">
            <h3 class="step--label">New Notes Added</h3>
            <div class="notes__container">
                <div v-for="note in addedNotes" :key="note" class="note">
                    <blockquote v-html="note"></blockquote>
                </div>
                <div v-if="addedNotes.length === 0">
                    <p class="no-notes">No disposition notes available</p>
                </div>
            </div>
        </div>

        <div class="conditions__loader-container" v-if="isLoading">
            <loader :size="'large'" :type="'infinite-spinner'"></loader>
        </div>
    </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';

    import cloneDeep from 'lodash.clonedeep';

    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Button } from '@progress/kendo-vue-buttons';
    import { Input } from '@progress/kendo-vue-inputs';
    import { Fade, Reveal, Slide } from "@progress/kendo-vue-animation";

    import { filterBy } from '@progress/kendo-data-query';

    import loanNotesComponent from './loanNotesComponent.vue';

    export default {
        props: ['finishClicked', 'loanId', 'wizardStep'],
        emits: ['loanrestructured', 'requestfailed', 'cleartofinish'],
        data() {
            return {
                addedNotes: [],
                errorMsg: '',
                errorTitle: '',
                isLoading: false,
                milestones: [
                    { milestoneName: 'Completion', id: '', doneIndicator: null },
                    { milestoneName: 'Post Closing', id: '', doneIndicator: null },
                    { milestoneName: 'Note Delivery', id: '', doneIndicator: null },
                    { milestoneName: 'Purchased', id: '', doneIndicator: null },
                    { milestoneName: 'Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Correspondent Funding', id: '', doneIndicator: null },
                    { milestoneName: 'Docs Signing', id: '', doneIndicator: null },
                    { milestoneName: 'Doc Preparation', id: '', doneIndicator: null },
                    { milestoneName: 'QC Review', id: '', doneIndicator: null },
                    { milestoneName: 'Approval', id: '', doneIndicator: null },
                    { milestoneName: 'Resubmittal', id: '', doneIndicator: null },
                    { milestoneName: "Cond'l Approval", id: '', doneIndicator: null },
                    { milestoneName: 'Submittal', id: '', doneIndicator: null }
                ],
                showErrorDialog: false
            }
        },
        watch: {
            wizardStep(val) {
            },
            finishClicked(val) {
                if (val) {
                    this.dispositionLoan();
                }
            }
        },
        mounted() {
            this.$emit('cleartofinish', true);
            this.getMilestones();
        },
        methods: {
            addWizardNote(noteHtml) {
                this.addedNotes.push(noteHtml);
            },
            async dispositionLoan() {
                let unfinishMilestones = this.milestones.filter(milestone => milestone.doneIndicator).map(milestone => milestone.id);

                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.RestructureLoan(this.loanId, unfinishMilestones, tokenResponse.accessToken)
                    .then(res => {
                        this.isLoading = false;
                        return this.$emit('loanrestructured', 'File dispositioned successfully')
                    }).catch(error => {
                        this.errorTitle = 'Failed to Disposition Loan';

                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                        this.$emit('requestfailed');
                    });
            },
            async getMilestones(update = false) {
                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.GetMilestones(this.loanId, tokenResponse.accessToken)
                    .then(res => {
                        if (res.data.data) {
                            this.milestones.forEach(milestone => {
                                let ms = res.data.data.find(m => m.milestoneName === milestone.milestoneName);

                                if (ms) {
                                    milestone.id = ms.id;
                                    milestone.doneIndicator = ms.doneIndicator;
                                }
                            });
                        }
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Milestones';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.toggleErrorDialog();
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if (!this.showErrorDialog) {
                    this.errorMsg = '';
                    this.errorTitle = '';
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'loan-notes-component': loanNotesComponent,
            'loader': Loader,
            'k-button': Button,
            'k-dropdown': DropDownList,
            'k-input': Input,
            'k-fade': Fade
        }
    }
</script>

<style>
    @import '/src/assets/css/conditionallyApproveWizard.css';
    @import '/src/assets/css/restructureWizard.css';
</style>